/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  NotFoundErrorResult,
  QuoteReportOptionsViewModel,
  Result,
  ResultOfProposalSummaryViewModel,
  ValidationErrorResult,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    QuoteReportOptionsViewModelFromJSON,
    QuoteReportOptionsViewModelToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfProposalSummaryViewModelFromJSON,
    ResultOfProposalSummaryViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface ProposalSummaryGetRequest {
    id: number;
}

export interface ProposalSummaryGetQuotePdfRequest {
    id: number;
    quoteReportOptionsViewModel: QuoteReportOptionsViewModel;
}

export interface ProposalSummaryMoveToApplicationRequest {
    proposalId: number;
}

/**
 * 
 */
export class ProposalSummaryApi extends runtime.BaseAPI {

    /**
     * Gets proposal summary for by proposal ID.
     */
    async proposalSummaryGetRaw(requestParameters: ProposalSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfProposalSummaryViewModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling proposalSummaryGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/proposal-summary/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfProposalSummaryViewModelFromJSON(jsonValue));
    }

    /**
     * Gets proposal summary for by proposal ID.
     */
    async proposalSummaryGet(requestParameters: ProposalSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfProposalSummaryViewModel> {
        const response = await this.proposalSummaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the quote PDF.
     */
    async proposalSummaryGetQuotePdfRaw(requestParameters: ProposalSummaryGetQuotePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling proposalSummaryGetQuotePdf.');
        }

        if (requestParameters.quoteReportOptionsViewModel === null || requestParameters.quoteReportOptionsViewModel === undefined) {
            throw new runtime.RequiredError('quoteReportOptionsViewModel','Required parameter requestParameters.quoteReportOptionsViewModel was null or undefined when calling proposalSummaryGetQuotePdf.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/proposal-summary/{id}/quote-pdf`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            body: QuoteReportOptionsViewModelToJSON(requestParameters.quoteReportOptionsViewModel),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Gets the quote PDF.
     */
    async proposalSummaryGetQuotePdf(requestParameters: ProposalSummaryGetQuotePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.proposalSummaryGetQuotePdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Move Proposal to Application in Progress
     */
    async proposalSummaryMoveToApplicationRaw(requestParameters: ProposalSummaryMoveToApplicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling proposalSummaryMoveToApplication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/proposal-summary/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Move Proposal to Application in Progress
     */
    async proposalSummaryMoveToApplication(requestParameters: ProposalSummaryMoveToApplicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.proposalSummaryMoveToApplicationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
